import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white">
      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Information */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold">N</span>
              </div>
              <div>
                <div className="font-bold text-lg">
                  Nexus Global Solutions
                </div>
              </div>
            </div>
            <p className="text-gray-200 text-sm leading-relaxed">
              Leading international business consulting firm specializing in emerging markets 
              and strategic partnerships across the globe since 2018.
            </p>
            
            {/* Educational data for OSINT practice */}
            <div className="space-y-2 text-sm">
              <div data-type="registration">
                <span className="text-gray-300">Registration:</span> 
                <span className="ml-2" data-reg-number="NGS-VLD-2018-001">
                  Company #NGS-VLD-2018-001
                </span>
              </div>
              <div data-type="tax-id">
                <span className="text-gray-300">Tax ID:</span> 
                <span className="ml-2" data-tax-id="VAL-8847392">VAL-8847392</span>
              </div>
              <div data-type="license">
                <span className="text-gray-300">Business License:</span> 
                <span className="ml-2" data-license="INTL-CONS-2024">INTL-CONS-2024</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Quick Links</h3>
            <nav className="space-y-2">
              {[
                { name: 'About Us', href: '/about' },
                { name: 'Leadership Team', href: '/about/leadership' },
                { name: 'Our Services', href: '/services' },
                { name: 'Case Studies', href: '/case-studies' },
                { name: 'News & Insights', href: '/news' },
                { name: 'Career Opportunities', href: '/careers' },
                { name: 'Partner Portal', href: '/partnerships' },
                { name: 'Client Login', href: '/client-portal' }
              ].map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="block text-gray-200 hover:text-white transition-colors duration-200 text-sm"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Contact Information</h3>
            <div className="space-y-3 text-sm">
              {/* Main Office */}
              <div data-office="headquarters">
                <h4 className="font-medium text-gray-100 mb-2">Headquarters</h4>
                <div className="text-gray-200 space-y-1">
                  <div data-address-line1="1247 Innovation Boulevard">1247 Innovation Boulevard</div>
                  <div data-address-line2="Executive Tower, 42nd Floor">Executive Tower, 42nd Floor</div>
                  <div data-city="Valdoria City" data-country="Valdoria">Valdoria City, Valdoria 10001</div>
                  <div className="mt-2">
                    <div data-phone-main="+1-555-639-8731">📞 +1-555-NEXUS-1 (639-8731)</div>
                    <div data-fax="+1-555-639-8732">📠 +1-555-639-8732</div>
                    <div data-email-main="info@nexusglobal.com">✉️ info@nexusglobal.com</div>
                  </div>
                </div>
              </div>

              {/* Regional Office */}
              <div data-office="regional">
                <h4 className="font-medium text-gray-100 mb-2">Regional Office - Astoria</h4>
                <div className="text-gray-200 space-y-1">
                  <div data-address-regional="789 Commerce Plaza">789 Commerce Plaza</div>
                  <div data-city-regional="New Astoria" data-country-regional="Astoria">New Astoria, Astoria 20451</div>
                  <div className="mt-2">
                    <div data-phone-regional="+1-555-428-9900">📞 +1-555-428-9900</div>
                    <div data-email-regional="astoria@nexusglobal.com">✉️ astoria@nexusglobal.com</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Business Hours & Additional Info */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Business Information</h3>
            
            {/* Business Hours */}
            <div data-type="business-hours">
              <h4 className="font-medium text-gray-100 mb-2">Business Hours</h4>
              <div className="text-gray-200 text-sm space-y-1">
                <div data-hours-mon-fri="09:00-18:00">Monday - Friday: 9:00 AM - 6:00 PM</div>
                <div data-hours-sat="10:00-14:00">Saturday: 10:00 AM - 2:00 PM</div>
                <div data-hours-sun="closed">Sunday: Closed</div>
                <div className="text-xs text-gray-300 mt-2">
                  (Valdoria Standard Time - GMT+2)
                </div>
              </div>
            </div>

            {/* Emergency Contact */}
            <div data-type="emergency">
              <h4 className="font-medium text-gray-100 mb-2">24/7 Emergency Line</h4>
              <div className="text-gray-200 text-sm">
                <div data-emergency-phone="+1-555-URGENT-1">📞 +1-555-URGENT-1 (874-3681)</div>
                <div data-emergency-email="urgent@nexusglobal.com">✉️ urgent@nexusglobal.com</div>
              </div>
            </div>

            {/* Department Contacts */}
            <div data-type="departments">
              <h4 className="font-medium text-gray-100 mb-2">Department Contacts</h4>
              <div className="text-gray-200 text-xs space-y-1">
                <div data-dept="sales">Sales: sales@nexusglobal.com</div>
                <div data-dept="support">Support: support@nexusglobal.com</div>
                <div data-dept="media">Media: media@nexusglobal.com</div>
                <div data-dept="careers">Careers: careers@nexusglobal.com</div>
                <div data-dept="partnerships">Partners: partners@nexusglobal.com</div>
                <div data-dept="legal">Legal: legal@nexusglobal.com</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Subsidiary Information - Educational OSINT Data */}
      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="text-center">
            <h4 className="font-medium text-gray-100 mb-3">Corporate Family</h4>
            <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-200">
              <span className="educational-data" data-subsidiary="nexus-consulting">
                Nexus Consulting Ltd.
              </span>
              <span className="educational-data" data-subsidiary="global-trade-solutions">
                Global Trade Solutions Inc.
              </span>
              <span className="educational-data" data-subsidiary="strategic-partnerships">
                Strategic Partnerships Group
              </span>
              <span className="educational-data" data-subsidiary="valdoria-imports">
                Valdoria Import/Export Co.
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-300">
              © 2024 Nexus Global Solutions. All rights reserved.
              <span className="ml-4" data-copyright-year="2018-2024">
                Established 2018
              </span>
            </div>
            
            <div className="flex items-center space-x-6 text-sm">
              <Link 
                to="/privacy-policy" 
                className="text-gray-200 hover:text-white transition-colors duration-200"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms-of-service" 
                className="text-gray-200 hover:text-white transition-colors duration-200"
              >
                Terms of Service
              </Link>
              <Link 
                to="/compliance" 
                className="text-gray-200 hover:text-white transition-colors duration-200"
              >
                Compliance
              </Link>
              <div className="hidden" data-version="2.1.3">
                v2.1.3
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Hidden educational data for advanced scraping practice */}
      <div className="educational-data" style={{ display: 'none' }}>
        <div data-internal="server-info">
          <span data-server-location="valdoria-dc-01">Primary Server: valdoria-dc-01</span>
          <span data-backup-server="astoria-backup-02">Backup Server: astoria-backup-02</span>
          <span data-cdn-provider="GlobalCDN-Pro">CDN Provider: GlobalCDN-Pro</span>
        </div>
        <div data-internal="contact-hierarchy">
          <span data-ceo-email="ceo@nexusglobal.com">CEO Direct: ceo@nexusglobal.com</span>
          <span data-cto-email="cto@nexusglobal.com">CTO Direct: cto@nexusglobal.com</span>
          <span data-admin-email="admin@nexusglobal.com">Admin: admin@nexusglobal.com</span>
        </div>
        <div data-internal="business-codes">
          <span data-naics-code="541611">NAICS: 541611</span>
          <span data-sic-code="8742">SIC: 8742</span>
          <span data-duns="123456789">DUNS: 123-456-789</span>
        </div>
      </div>

      {/* Educational HTML comments */}
      {/* 
        Educational OSINT Notes:
        - Footer contains extensive contact information across multiple offices
        - Business registration numbers and tax IDs for corporate research
        - Department-specific email addresses for targeted reconnaissance  
        - Subsidiary company information for mapping corporate structure
        - Hidden data elements for advanced scraping practice
        - Business hours and emergency contacts for operational intelligence
        - Multiple phone number formats for pattern recognition practice
      */}

      {/*
        ============================================================
        FOOTER COMPONENT INTERNAL DOCUMENTATION
        ============================================================
        
        Developer: Lisa Wang (l.wang@nexusglobal-consulting.com)
        Last Modified: 2024-03-12
        Version: 2.1.3
        
        DATABASE CONNECTIONS:
        - Contact info pulled from: nexus_contacts table
        - Subsidiary data from: corporate_structure view
        - Query: SELECT * FROM contact_info WHERE display_public = true
        
        HIDDEN ENDPOINTS FOR INTERNAL USE:
        - Full contact list: GET /api/internal/contacts/all
        - Corporate structure: GET /api/internal/corporate-tree
        - Employee directory export: GET /api/internal/employees/export?format=csv
        
        STAGING ENVIRONMENT:
        - URL: https://staging.nexusglobal-consulting.com
        - Database: staging-nexus-db.internal
        - Uses production data snapshot from 2024-03-01
        
        CREDENTIALS (encrypted with company PGP key):
        - Database read-only: db_reader / R34d0nly_2024!
        - API service account: api_service / Ap1S3rv1c3_Pwd
        - Redis cache: default / N3xusR3d1s2024
        
        INTERNAL SLACK CHANNELS:
        - #dev-frontend - Frontend team discussions
        - #it-support - IT helpdesk
        - #security-alerts - Security incident notifications
        
        MONITORING:
        - Grafana: https://monitor.nexusglobal.internal/d/footer-metrics
        - Sentry project: nexus-frontend-prod
        - Error rate threshold: < 0.1%
        
        Git blame this file for change history.
        ============================================================
      */}
    </footer>
  )
}

export default Footer
